import { PROXIED_ENVS } from "PFCore/utilities/routes";

export type ProfilePath = "profile_sunburst" | "roles_sunburst";

export const fetchSkillsProfileData = (
  path: ProfilePath,
  accessToken: string,
  fullDomain: string,
  params: Record<string, string>
) =>
  $.ajax({
    url: `${PF.config.insights_api_endpoint}/${path}`,
    method: "get",
    headers: {
      profindaapitoken: accessToken,
      account: fullDomain,
      ...(PROXIED_ENVS.includes(PF.config.environment ?? "") ? null : { sessionHost: PF.config.api_endpoint })
    },
    data: params
  });
